import * as Preact from 'preact';
import Typography from '@mui/material/Typography';
import * as Button from './A_Button';
import { Box } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useTranslations } from './utils/TranslationsWrapper';
export var Component = function (props) {
    var t = useTranslations().t;
    return (Preact.h(Box, { width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "26px", bgcolor: "white" },
        Preact.h(ErrorOutlineIcon, { color: "primary" }),
        Preact.h(Box, { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "8px" },
            Preact.h(Typography, { variant: "h6" }, t('error.app.primary')),
            Preact.h(Typography, { variant: "body1", textAlign: "center" }, t('error.app.secondary'))),
        Preact.h(Button.Component, { size: "medium", color: "primary", variant: "contained", onClick: props.onCloseClick }, t('error.app.close'))));
};
Component.displayName = 'ErrorPage';
